import { render } from "./Proveedor_Configuracion.vue?vue&type=template&id=1f63bf0e"
import script from "./Proveedor_Configuracion.vue?vue&type=script&lang=js"
export * from "./Proveedor_Configuracion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__